/**
 * Arborsense API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 12.2.8 (4a3936f)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { PeakEvents } from '../model/peakEvents';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface PeakEventsDeleteRequestParams {
    id?: string;
    sequenceId?: string;
    eventId?: string;
    eventNumber?: string;
    startedAt?: string;
    endedAt?: string;
    peakTacAt?: string;
    peakTacValue?: string;
    peakProminenceValue?: string;
    durationMinutes?: string;
    hourThresholdDuration?: string;
    halfHourThresholdDuration?: string;
    eventRiseSlope?: string;
    eventFallSlope?: string;
    areaUnderCurve?: string;
    createdAt?: string;
    updatedAt?: string;
    /** Preference */
    prefer?: 'return=representation' | 'return=minimal' | 'return=none';
}

export interface PeakEventsGetRequestParams {
    id?: string;
    sequenceId?: string;
    eventId?: string;
    eventNumber?: string;
    startedAt?: string;
    endedAt?: string;
    peakTacAt?: string;
    peakTacValue?: string;
    peakProminenceValue?: string;
    durationMinutes?: string;
    hourThresholdDuration?: string;
    halfHourThresholdDuration?: string;
    eventRiseSlope?: string;
    eventFallSlope?: string;
    areaUnderCurve?: string;
    createdAt?: string;
    updatedAt?: string;
    /** Filtering Columns */
    select?: string;
    /** Ordering */
    order?: string;
    /** Limiting and Pagination */
    range?: string;
    /** Limiting and Pagination */
    rangeUnit?: string;
    /** Limiting and Pagination */
    offset?: string;
    /** Limiting and Pagination */
    limit?: string;
    /** Preference */
    prefer?: 'count=none';
}

export interface PeakEventsPatchRequestParams {
    id?: string;
    sequenceId?: string;
    eventId?: string;
    eventNumber?: string;
    startedAt?: string;
    endedAt?: string;
    peakTacAt?: string;
    peakTacValue?: string;
    peakProminenceValue?: string;
    durationMinutes?: string;
    hourThresholdDuration?: string;
    halfHourThresholdDuration?: string;
    eventRiseSlope?: string;
    eventFallSlope?: string;
    areaUnderCurve?: string;
    createdAt?: string;
    updatedAt?: string;
    /** Preference */
    prefer?: 'return=representation' | 'return=minimal' | 'return=none';
    /** peak_events */
    peakEvents?: PeakEvents;
}

export interface PeakEventsPostRequestParams {
    /** Filtering Columns */
    select?: string;
    /** Preference */
    prefer?: 'return=representation' | 'return=minimal' | 'return=none' | 'resolution=ignore-duplicates' | 'resolution=merge-duplicates';
    /** peak_events */
    peakEvents?: PeakEvents;
}


@Injectable({
  providedIn: 'root'
})
export class PeakEventsService {

    protected basePath = 'http://0.0.0.0:3000';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public peakEventsDelete(requestParameters: PeakEventsDeleteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public peakEventsDelete(requestParameters: PeakEventsDeleteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public peakEventsDelete(requestParameters: PeakEventsDeleteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public peakEventsDelete(requestParameters: PeakEventsDeleteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        const sequenceId = requestParameters.sequenceId;
        const eventId = requestParameters.eventId;
        const eventNumber = requestParameters.eventNumber;
        const startedAt = requestParameters.startedAt;
        const endedAt = requestParameters.endedAt;
        const peakTacAt = requestParameters.peakTacAt;
        const peakTacValue = requestParameters.peakTacValue;
        const peakProminenceValue = requestParameters.peakProminenceValue;
        const durationMinutes = requestParameters.durationMinutes;
        const hourThresholdDuration = requestParameters.hourThresholdDuration;
        const halfHourThresholdDuration = requestParameters.halfHourThresholdDuration;
        const eventRiseSlope = requestParameters.eventRiseSlope;
        const eventFallSlope = requestParameters.eventFallSlope;
        const areaUnderCurve = requestParameters.areaUnderCurve;
        const createdAt = requestParameters.createdAt;
        const updatedAt = requestParameters.updatedAt;
        const prefer = requestParameters.prefer;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (sequenceId !== undefined && sequenceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sequenceId, 'sequence_id');
        }
        if (eventId !== undefined && eventId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventId, 'event_id');
        }
        if (eventNumber !== undefined && eventNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventNumber, 'event_number');
        }
        if (startedAt !== undefined && startedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startedAt, 'started_at');
        }
        if (endedAt !== undefined && endedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endedAt, 'ended_at');
        }
        if (peakTacAt !== undefined && peakTacAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakTacAt, 'peak_tac_at');
        }
        if (peakTacValue !== undefined && peakTacValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakTacValue, 'peak_tac_value');
        }
        if (peakProminenceValue !== undefined && peakProminenceValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakProminenceValue, 'peak_prominence_value');
        }
        if (durationMinutes !== undefined && durationMinutes !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>durationMinutes, 'duration_minutes');
        }
        if (hourThresholdDuration !== undefined && hourThresholdDuration !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>hourThresholdDuration, 'hour_threshold_duration');
        }
        if (halfHourThresholdDuration !== undefined && halfHourThresholdDuration !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>halfHourThresholdDuration, 'half_hour_threshold_duration');
        }
        if (eventRiseSlope !== undefined && eventRiseSlope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventRiseSlope, 'event_rise_slope');
        }
        if (eventFallSlope !== undefined && eventFallSlope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventFallSlope, 'event_fall_slope');
        }
        if (areaUnderCurve !== undefined && areaUnderCurve !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaUnderCurve, 'area_under_curve');
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'created_at');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updated_at');
        }

        let localVarHeaders = this.defaultHeaders;
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/peak_events`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public peakEventsGet(requestParameters: PeakEventsGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Array<PeakEvents>>;
    public peakEventsGet(requestParameters: PeakEventsGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<PeakEvents>>>;
    public peakEventsGet(requestParameters: PeakEventsGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<PeakEvents>>>;
    public peakEventsGet(requestParameters: PeakEventsGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        const sequenceId = requestParameters.sequenceId;
        const eventId = requestParameters.eventId;
        const eventNumber = requestParameters.eventNumber;
        const startedAt = requestParameters.startedAt;
        const endedAt = requestParameters.endedAt;
        const peakTacAt = requestParameters.peakTacAt;
        const peakTacValue = requestParameters.peakTacValue;
        const peakProminenceValue = requestParameters.peakProminenceValue;
        const durationMinutes = requestParameters.durationMinutes;
        const hourThresholdDuration = requestParameters.hourThresholdDuration;
        const halfHourThresholdDuration = requestParameters.halfHourThresholdDuration;
        const eventRiseSlope = requestParameters.eventRiseSlope;
        const eventFallSlope = requestParameters.eventFallSlope;
        const areaUnderCurve = requestParameters.areaUnderCurve;
        const createdAt = requestParameters.createdAt;
        const updatedAt = requestParameters.updatedAt;
        const select = requestParameters.select;
        const order = requestParameters.order;
        const range = requestParameters.range;
        const rangeUnit = requestParameters.rangeUnit;
        const offset = requestParameters.offset;
        const limit = requestParameters.limit;
        const prefer = requestParameters.prefer;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (sequenceId !== undefined && sequenceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sequenceId, 'sequence_id');
        }
        if (eventId !== undefined && eventId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventId, 'event_id');
        }
        if (eventNumber !== undefined && eventNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventNumber, 'event_number');
        }
        if (startedAt !== undefined && startedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startedAt, 'started_at');
        }
        if (endedAt !== undefined && endedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endedAt, 'ended_at');
        }
        if (peakTacAt !== undefined && peakTacAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakTacAt, 'peak_tac_at');
        }
        if (peakTacValue !== undefined && peakTacValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakTacValue, 'peak_tac_value');
        }
        if (peakProminenceValue !== undefined && peakProminenceValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakProminenceValue, 'peak_prominence_value');
        }
        if (durationMinutes !== undefined && durationMinutes !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>durationMinutes, 'duration_minutes');
        }
        if (hourThresholdDuration !== undefined && hourThresholdDuration !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>hourThresholdDuration, 'hour_threshold_duration');
        }
        if (halfHourThresholdDuration !== undefined && halfHourThresholdDuration !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>halfHourThresholdDuration, 'half_hour_threshold_duration');
        }
        if (eventRiseSlope !== undefined && eventRiseSlope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventRiseSlope, 'event_rise_slope');
        }
        if (eventFallSlope !== undefined && eventFallSlope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventFallSlope, 'event_fall_slope');
        }
        if (areaUnderCurve !== undefined && areaUnderCurve !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaUnderCurve, 'area_under_curve');
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'created_at');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updated_at');
        }
        if (select !== undefined && select !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>select, 'select');
        }
        if (order !== undefined && order !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>order, 'order');
        }
        if (offset !== undefined && offset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offset, 'offset');
        }
        if (limit !== undefined && limit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>limit, 'limit');
        }

        let localVarHeaders = this.defaultHeaders;
        if (range !== undefined && range !== null) {
            localVarHeaders = localVarHeaders.set('Range', String(range));
        }
        if (rangeUnit !== undefined && rangeUnit !== null) {
            localVarHeaders = localVarHeaders.set('Range-Unit', String(rangeUnit));
        }
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/vnd.pgrst.object+json;nulls=stripped',
                'application/vnd.pgrst.object+json',
                'text/csv'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/peak_events`;
        return this.httpClient.request<Array<PeakEvents>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public peakEventsPatch(requestParameters: PeakEventsPatchRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public peakEventsPatch(requestParameters: PeakEventsPatchRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public peakEventsPatch(requestParameters: PeakEventsPatchRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public peakEventsPatch(requestParameters: PeakEventsPatchRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        const sequenceId = requestParameters.sequenceId;
        const eventId = requestParameters.eventId;
        const eventNumber = requestParameters.eventNumber;
        const startedAt = requestParameters.startedAt;
        const endedAt = requestParameters.endedAt;
        const peakTacAt = requestParameters.peakTacAt;
        const peakTacValue = requestParameters.peakTacValue;
        const peakProminenceValue = requestParameters.peakProminenceValue;
        const durationMinutes = requestParameters.durationMinutes;
        const hourThresholdDuration = requestParameters.hourThresholdDuration;
        const halfHourThresholdDuration = requestParameters.halfHourThresholdDuration;
        const eventRiseSlope = requestParameters.eventRiseSlope;
        const eventFallSlope = requestParameters.eventFallSlope;
        const areaUnderCurve = requestParameters.areaUnderCurve;
        const createdAt = requestParameters.createdAt;
        const updatedAt = requestParameters.updatedAt;
        const prefer = requestParameters.prefer;
        const peakEvents = requestParameters.peakEvents;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (sequenceId !== undefined && sequenceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sequenceId, 'sequence_id');
        }
        if (eventId !== undefined && eventId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventId, 'event_id');
        }
        if (eventNumber !== undefined && eventNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventNumber, 'event_number');
        }
        if (startedAt !== undefined && startedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startedAt, 'started_at');
        }
        if (endedAt !== undefined && endedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endedAt, 'ended_at');
        }
        if (peakTacAt !== undefined && peakTacAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakTacAt, 'peak_tac_at');
        }
        if (peakTacValue !== undefined && peakTacValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakTacValue, 'peak_tac_value');
        }
        if (peakProminenceValue !== undefined && peakProminenceValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>peakProminenceValue, 'peak_prominence_value');
        }
        if (durationMinutes !== undefined && durationMinutes !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>durationMinutes, 'duration_minutes');
        }
        if (hourThresholdDuration !== undefined && hourThresholdDuration !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>hourThresholdDuration, 'hour_threshold_duration');
        }
        if (halfHourThresholdDuration !== undefined && halfHourThresholdDuration !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>halfHourThresholdDuration, 'half_hour_threshold_duration');
        }
        if (eventRiseSlope !== undefined && eventRiseSlope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventRiseSlope, 'event_rise_slope');
        }
        if (eventFallSlope !== undefined && eventFallSlope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>eventFallSlope, 'event_fall_slope');
        }
        if (areaUnderCurve !== undefined && areaUnderCurve !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaUnderCurve, 'area_under_curve');
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'created_at');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updated_at');
        }

        let localVarHeaders = this.defaultHeaders;
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/vnd.pgrst.object+json;nulls=stripped',
            'application/vnd.pgrst.object+json',
            'text/csv'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/peak_events`;
        return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: peakEvents,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public peakEventsPost(requestParameters: PeakEventsPostRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public peakEventsPost(requestParameters: PeakEventsPostRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public peakEventsPost(requestParameters: PeakEventsPostRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public peakEventsPost(requestParameters: PeakEventsPostRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const select = requestParameters.select;
        const prefer = requestParameters.prefer;
        const peakEvents = requestParameters.peakEvents;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (select !== undefined && select !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>select, 'select');
        }

        let localVarHeaders = this.defaultHeaders;
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/vnd.pgrst.object+json;nulls=stripped',
            'application/vnd.pgrst.object+json',
            'text/csv'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/peak_events`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: peakEvents,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
